export default __webpack_public_path__ + "static/media/Outdoor-hover.5364a2a7.svg";